module.exports = __webpack_public_path__ + "img/box_parked.90c9f0f4.svg";